<template>
  <UiInputCheckboxGroupVee
    name="userWorkAreas"
    :label="$t('term.work-areas')"
    :options="workAreaOptions"
    v-model="proxyWorkAreas" />
</template>

<script lang="ts">
import type { LabManagementUser } from '@/globals/typescript/models/LabManagementUser'
import {
  getRoleDescription,
  getRoleDisplayName,
} from '@/globals/typescript/utils/roleUtils'
import { useUserStore } from '@/stores/userStore'
import {
  labManagementWorkAreas,
  type TLabManagementWorkArea,
} from '@team-milva/lab-models/user'
import { mapState } from 'pinia'
import type { PropType } from 'vue'

type TWorkAreaSelectionOption = {
  value: TLabManagementWorkArea
  text: string
  description?: string
  isDisabled?: boolean
}

export default {
  name: 'WorkAreaSelection',
  emits: ['update:userWorkAreas'],
  props: {
    user: {
      type: Object as PropType<LabManagementUser | null>,
      default: null,
    },
    userWorkAreas: {
      type: Array as PropType<TLabManagementWorkArea[]>,
      required: true,
    },
  },
  computed: {
    ...mapState(useUserStore, ['currentUser']),
    isOwnUser(): boolean {
      return !!this.user && this.user.id === this.currentUser?.id
    },
    allowedWorkAreas(): TLabManagementWorkArea[] {
      return this.currentUser?.getAllowedWorkAreasToManage() ?? []
    },
    canEditWorkAreas(): boolean {
      if (this.isOwnUser) {
        return this.currentUser?.canEditOwnWorkAreas() ?? false
      }

      return true
    },
    proxyWorkAreas: {
      get(): TLabManagementWorkArea[] {
        return this.userWorkAreas
      },
      set(value: TLabManagementWorkArea[]) {
        this.$emit('update:userWorkAreas', value)
      },
    },
    workAreaOptions(): TWorkAreaSelectionOption[] {
      return labManagementWorkAreas.map((workArea) => ({
        value: workArea,
        text: getRoleDisplayName(workArea),
        description: getRoleDescription(workArea),
        isDisabled:
          !this.canEditWorkAreas || !this.allowedWorkAreas.includes(workArea),
      }))
    },
  },
}
</script>
